import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { apiUrl } from '../config/api';

function DeleteUserDialog({ user, onClose, onSuccess }: { user: any; onClose: () => void; onSuccess: () => void }) {
  const token = useSelector((state: RootState) => state.auth.token);

  const handleDelete = async () => {
    const confirmed = window.confirm('Willst du diesen Nutzer wirklich löschen?');
    if (!confirmed) return;

    try {
      const res = await fetch(apiUrl(`/api/users/${user._id}`), {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const err = await res.json();
        alert(err.message || 'Fehler beim Löschen');
        return;
      }

      alert('Benutzer erfolgreich gelöscht.');
      onSuccess();
    } catch {
      alert('Fehler beim Löschen.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="card p-4 shadow-sm" style={{ maxWidth: 400, margin: 'auto' }}>
        <h4 className="mb-3">Benutzer löschen</h4>
        <p>Möchtest du den Benutzer <strong>{user.username}</strong> wirklich löschen?</p>
        <div className="d-flex justify-content-between">
          <button className="btn btn-secondary" onClick={onClose}>
            Abbrechen
          </button>
          <button className="btn btn-danger" onClick={handleDelete}>
            Löschen
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteUserDialog;
